module.exports = __webpack_public_path__ + "img/cuentas-an.28405c91.png";